import React from "react";
import { BaseDialogModalWindow } from "@/components/modules/Post/BaseDialogModalWindow";
import Link from "next/link";
import { useAuthUrls } from "@/hooks/useAuthUrls";

export const DialogModalWindow: React.FC<{
  title: string;
  text?: string;
  button: React.ReactNode;
  label?: string;
  isOpen: boolean;
  onClose: () => void;
}> = ({ title, isOpen, text, button, label, onClose }) => {
  const { getLoginUrl } = useAuthUrls();

  return (
    <BaseDialogModalWindow isOpen={isOpen} onClose={onClose}>
      <h3 className="mb-[8px] font-mercury text-xl font-semibold text-dark">{title}</h3>
      <div className="mb-[24px]">
        <p className="font-body font-light text-dark-70">{text}</p>
      </div>
      <div className="flex w-full flex-col gap-[16px] md:flex-row">
        <div className="w-full overflow-hidden rounded-full">{button}</div>
        {/* TODO: change for transparent button when it's merged from other PR */}
        <button
          type="button"
          className="block w-full cursor-pointer rounded-full border border-gray-300 p-3 text-center font-sans text-sm transition-colors ease-in-out hover:bg-dark/5 active:bg-dark/10"
          onClick={onClose}
        >
          Teď ne
        </button>
      </div>
      {label && (
        <p className="mt-[24px] font-body font-light text-dark-70">
          {label}
          {", "}
          <Link
            href={getLoginUrl()}
            className="text-blue no-underline decoration-1 underline-offset-4 hover:decoration-blue dark:text-middle-light-turquoise dark:hover:decoration-light-turquoise md:hover:underline"
          >
            přihlaste se
          </Link>
        </p>
      )}
    </BaseDialogModalWindow>
  );
};
